module.exports = __webpack_public_path__ + "img/6.dc2bf15c.jpg";